{
  "name": "@ns/verify-staff-claims",
  "version": "1.0.0",
  "description": "Verify the organisational claims made by your staff.",
  "inputs": {
    "staff": {
      "type": "array"
    },
    "type": {
      "type": "string"
    }
  },
  "outcomes": {
    "complete": {}
  },
  "jobMetadata": [
    "LIST"
  ]
}
